export default __webpack_public_path__ + "static/media/langer_bus_hinten.f861874a.jpg";